import React, { Component } from 'react'
import { connect } from 'react-redux'
import Axios from 'axios';
import ProjectTransferTableRow from "../../../components/Settings/ProjectTransferTableRow/ProjectTransferTableRow";
import "./TransferProject.scss"
import SettingsWrapper from "../../../components/Settings/SettingsWrapper";
import translator from "../../../utils/translator";

export class TransferProject extends Component {
    state = {
        search_input: "",
        project_table_rows: [],
        viewing_this_page_number: 1,
        pagination_buttons: []
    }

    componentDidMount = async () => {
        try {
            let get_all_projects_API_URL = this.props.APIUrl + "/projects/search"
            let data = {
                user: localStorage.getItem("trendId"),
                page: 1,
                limit: 10,
                sort: "date_added",
                order: "DESC",
                active: 1,
                searchCriteria: ''
            }
            let get_all_projects_API_response = await Axios.post(get_all_projects_API_URL, data)

            console.log("here is the API response for getting all projects ", get_all_projects_API_response)

            let projects = get_all_projects_API_response.data.projects

            let create_project_transfer_table_row_components = await projects.map((project, index) => (
                <ProjectTransferTableRow
                    key={index}
                    project_ID={project.id} // We need to pass this when we call the transfer_project() function in the table row component
                    project_name={project.title}
                    warehouse_number={project.warehouse}
                    account_name={project.account_name}
                    project_status={project.archived ? translator("Admin Project Transfer", "project_status_archived") : translator("Admin Project Transfer", "project_status_active")}
                    transfer_project={this.transfer_project}
                />

            ));

            // -- Create the list of pagination buttons --
            let pagination_buttons = []
            for (let i = 1; i <= projects.length; i++) {
                let pagination_button = <button
                    key={i} 
                    onClick={() => this.search_for_projects(i)}
                    type="button"
                >
                    {i}
                </button>

                pagination_buttons.push(pagination_button)
            }

            this.setState({ project_table_rows: create_project_transfer_table_row_components, pagination_buttons })

        } catch (error) {
            console.log("here is the error message when getting all the projects in the transfer proejct page in settings", error.message)
        }
    }

    transfer_project = (project_ID) => {

    }

    // -- This function is used to search for projects and paginating --
    search_for_projects = async (clicked_on_this_page_number = 1) => {
        try {
            // -- Get all the projects and create the project table rows --
            let get_all_projects_API_URL = this.props.APIUrl + "/projects/search"
            let data = {
                user: localStorage.getItem("trendId"),
                page: clicked_on_this_page_number,
                limit: 10,
                sort: "date_added",
                order: "DESC",
                active: 1,
                searchCriteria: this.state.search_input
            }
            let get_all_projects_API_response = await Axios.post(get_all_projects_API_URL, data)

            console.log("here is the API response for getting all projects ", get_all_projects_API_response)
            let projects = get_all_projects_API_response.data.projects

            let create_project_transfer_table_row_components = await projects.map((project, index) => (
                <ProjectTransferTableRow
                    key={index}
                    project_ID={project.id} // We need to pass this when we call the transfer_project() function in the table row component
                    project_name={project.title}
                    warehouse_number={project.warehouse}
                    account_name={project.account_name}
                    project_status={project.archived ? translator("Admin Project Transfer", "project_status_archived") : translator("Admin Project Transfer", "project_status_active")}
                    transfer_project={this.transfer_project}
                />

            ));

            // -- Create the list of pagination buttons --
            let pagination_buttons = []
            for (let i = 1; i <= projects.length; i++) {
                let pagination_button = <button
                    key={i}
                    onClick={() => this.search_for_projects(i)}
                    type="button"
                >
                    {i}
                </button>

                pagination_buttons.push(pagination_button)
            }

            this.setState({ project_table_rows: create_project_transfer_table_row_components, pagination_buttons })

        } catch (error) {
            console.log("here is the error message when getting all the projects in the transfer proejct page in settings", error.message)
        }
    }

    render() {
        let main = (
            <>
                <div class="card user-profile-card">
                    <div class="card-body">
                        <form class="form-inline">
                            <input
                                class="form-control form-control-sm ml-3 w-75"
                                type="text"
                                placeholder={translator("Misc", "search_placeholder")}
                                aria-label="Search"
                                onChange={event =>
                                    this.setState({ search_input: event.target.value })
                                }
                            />
                            <button
                                onClick={() => this.search_for_projects()}
                                type="button"
                            >
                                <i class="fa fa-search" />
                            </button>
                        </form>
                    </div>
                </div>
                <div class="card user-profile-card">
                    <div class="card-body" />
                    <div className="SearchProjects_pagination_wrapper__2eLSn transfer-project-pagination-buttons">
                        {this.state.pagination_buttons.map(pagination_button => pagination_button)}
                    </div>
                    <table class="table search-results-table">
                        <thead id="search-projects-table-header">
                            <tr>
                                <th scope="col" >{translator("Admin Project Transfer", "project_name_col")}</th>
                                <th scope="col">{translator("Admin Project Transfer", "warehouse_col")}</th>
                                <th scope="col">{translator("Admin Project Transfer", "account_col")}</th>
                                <th scope="col">{translator("Admin Project Transfer", "status_col")}</th>
                                <th scope="col" />


                            </tr>
                        </thead>
                        <tbody>
                            {this.state.project_table_rows.map(project_table_row => project_table_row)}

                        </tbody>
                    </table>
                </div>
            </>
        );

        return (
			<SettingsWrapper header={translator("Admin Menu", "transfer_project_header")} main={main} />
		);
    }
}

const mapStateToProps = (state) => ({
    APIUrl: state.APIUrl
})

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(TransferProject)
